/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductRegisterResVo } from './ProductRegisterResVo';
import {
    ProductRegisterResVoFromJSON,
    ProductRegisterResVoFromJSONTyped,
    ProductRegisterResVoToJSON,
    ProductRegisterResVoToJSONTyped,
} from './ProductRegisterResVo';

/**
 * 
 * @export
 * @interface ResponseProductRegisterResVo
 */
export interface ResponseProductRegisterResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseProductRegisterResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseProductRegisterResVo
     */
    message?: string;
    /**
     * 
     * @type {ProductRegisterResVo}
     * @memberof ResponseProductRegisterResVo
     */
    data?: ProductRegisterResVo;
}

/**
 * Check if a given object implements the ResponseProductRegisterResVo interface.
 */
export function instanceOfResponseProductRegisterResVo(value: object): value is ResponseProductRegisterResVo {
    return true;
}

export function ResponseProductRegisterResVoFromJSON(json: any): ResponseProductRegisterResVo {
    return ResponseProductRegisterResVoFromJSONTyped(json, false);
}

export function ResponseProductRegisterResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseProductRegisterResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ProductRegisterResVoFromJSON(json['data']),
    };
}

export function ResponseProductRegisterResVoToJSON(json: any): ResponseProductRegisterResVo {
    return ResponseProductRegisterResVoToJSONTyped(json, false);
}

export function ResponseProductRegisterResVoToJSONTyped(value?: ResponseProductRegisterResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': ProductRegisterResVoToJSON(value['data']),
    };
}

